import JSCookie from 'js-cookie';
import { parseUTMCookie } from '@sravni/utils/lib/analytics';
import { AD_FOX_DICTIONARY } from '../src/constants/yandex.js';

const decorateParams = (banner, abName) => {
    if (!banner?.params) {
        return {};
    }
    const { tag, params } = banner;
    const mainParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (!value && value !== false)
            return acc;
        const normalizedValue = Array.isArray(value) ? value.join(':') : value.toString();
        if (!normalizedValue)
            return acc;
        // @ts-expect-error
        const tagFromAdFoxDictionary = AD_FOX_DICTIONARY[key];
        if (!tagFromAdFoxDictionary) {
            return {
                ...acc,
                [key]: normalizedValue,
            };
        }
        return {
            ...acc,
            [tagFromAdFoxDictionary]: normalizedValue,
        };
    }, {});
    const utmzCookie = JSCookie.get('__utmz');
    const { utmcmd, utmcsr } = parseUTMCookie(utmzCookie ?? '');
    const abCookie = abName && JSCookie.get(abName);
    return {
        slotTag: tag,
        ...mainParams,
        ...(utmcsr && { [AD_FOX_DICTIONARY.utmcsr]: utmcsr }),
        ...(utmcmd && { [AD_FOX_DICTIONARY.utmcmd]: utmcmd }),
        ...(abCookie && { [AD_FOX_DICTIONARY.ab_test]: `${abName}_${abCookie}` }),
    };
};

export { decorateParams };
//# sourceMappingURL=decorateParams.js.map
